export function undefOrNull(v: unknown) {
  return v === undefined || v === null;
}

export function undefOrNullOrEmptyStr(v: unknown) {
  return v === undefined || v === null || v === "";
}
